import { Platform } from "@src/mobile/utils/platform";

import { useIsHomeHealthEnabled } from "./useIsHomeHealthEnabled";
import { useIsHomeHealthWorkplaceMobileExperienceEnabled } from "./useIsHomeHealthWorkplaceMobileExperienceEnabled";

/**
 * True when the session is the Home Health workplace mobile experience running
 * inside the native Capacitor app. Use this — not `Platform.isMobile` alone —
 * to gate native-app layout behavior: the native app is overwhelmingly used by
 * non-HH workplaces whose pages split layouts by viewport, so device-wide gates
 * would change their experience too.
 */
export function useIsHomeHealthNativeMobileExperience(): boolean {
  const isHomeHealthEnabled = useIsHomeHealthEnabled();
  const isMobileExperienceEnabled = useIsHomeHealthWorkplaceMobileExperienceEnabled();

  return Platform.isMobile && isHomeHealthEnabled && isMobileExperienceEnabled;
}
